import React from 'react';
import { useHistory } from 'react-router-dom';
import ProjectListView from '../ProjectListView';

const SiteType = ({ sitesReady, realm, noSiteView }) => {
  const history = useHistory();
  const urlParams = new URLSearchParams(history.location.search);
  const createSiteType = urlParams.get('createSite') || 'default';

  return (
    <ProjectListView
      sitesReady={sitesReady}
      realm={realm}
      urlParams={urlParams}
      createSiteType={createSiteType.toLowerCase()}
      noSiteView={noSiteView}
    />
  );
};

export default SiteType;
